import { createSlice } from "@reduxjs/toolkit";
import { getRevenueChartsData } from './thunk';

export const initialState = {
  revenueData: { series: [], categories: [] },
  error: {}
};

const DashboardEcommerceSlice = createSlice({
  name: 'DashboardEcommerce',
  initialState,
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(getRevenueChartsData.fulfilled, (state, action) => {
      const p = action.payload;
      state.revenueData =
        p && (p.series || p.categories)
          ? p
          : { series: Array.isArray(p) ? p : [], categories: [] };
    });
    builder.addCase(getRevenueChartsData.rejected, (state, action) => {
      state.error = action.error.message;
    });
  }
});

export default DashboardEcommerceSlice.reducer;